import labels from '../localization/labels.json';
import labels_fr from '../localization/labels_fr.json';
class UtilitiesService {
    appLanguageUtil = (lang) => {
        if (lang === "EN") {
            return labels;
        }
        if (lang === "FR") {
            return labels_fr;
        }
    };

}

export default UtilitiesService;
const utitService = new UtilitiesService();
export { utitService }